import CXMApiClient from "../../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

const state = {};

const actions = {
    async getLinkedCustomersByContactId(context, contactId) {
        const scope = HelperFunctions.getCurrentCustomerScope();
        const cxmApiClient = new CXMApiClient();
        return await cxmApiClient.ProcessRequest("GET", `/crm/contacts/enterprise/${contactId}/linkedcontacts`, null, scope).catch(err => err.response);
    },
    async getPotentialCustomerLinksByContactId(context, contactId) {
        const scope = HelperFunctions.getCurrentCustomerScope();
        const cxmApiClient = new CXMApiClient();
        return await cxmApiClient.ProcessRequest("GET", `/crm/contacts/enterprise/${contactId}/potentialcustomerlinks`, null, scope).catch(err => err.response);
    },
    async linkCustomers(context, request) {
        const scope = HelperFunctions.getCurrentCustomerScope();
        const cxmApiClient = new CXMApiClient();
        return await cxmApiClient.ProcessRequest("POST", `/crm/contacts/enterprise/link_customer`, request, scope).catch(err => err.response);
    },
    async unlinkCustomers(context, request) {
        const scope = HelperFunctions.getCurrentCustomerScope();
        const cxmApiClient = new CXMApiClient();
        return await cxmApiClient.ProcessRequest("POST", `/crm/contacts/enterprise/unlink_customer`, request, scope).catch(err => err.response);
    },
    async getLifetimeValue(context, enterpriseCustomerId) {
        const scope = HelperFunctions.getCurrentCustomerScope();
        const cxmApiClient = new CXMApiClient();
        return await cxmApiClient.ProcessRequest("GET", `/crm/contacts/enterprise/${enterpriseCustomerId}/lifetime_value`, null, scope).catch(err => err.response);
    },
    async getContactLifetimeValue(context, contactId) {
        const scope = HelperFunctions.getCurrentCustomerScope();
        const cxmApiClient = new CXMApiClient();
        return await cxmApiClient.ProcessRequest("GET", `/crm/contacts/contact/${contactId}/lifetime_value`, null, scope).catch(err => err.response);
    }
}

export default {
    state,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/Enterprise.js